import { Reducer } from 'redux';

import { IShopsState, ShopsTypes } from './types';

const DEFAULT_STATE: IShopsState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<IShopsState> = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case ShopsTypes.LOAD_REQUEST:
      return { ...state, loading: true };
    case ShopsTypes.LOAD_SUCCESS:
      return { ...state, loading: false, error: false, data: action.payload };
    case ShopsTypes.LOAD_FAILURE:
      return { ...state, loading: false, error: true, data: [] };
    default:
      return state;
  }
};

export default reducer;
